// Replaces aws-exports.js. Configure these via environment variables at build
// time. Cloudflare Pages exposes anything prefixed with REACT_APP_.

const apiBaseFromEnv =
  typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE_URL;

const cloudinaryCloudFromEnv =
  typeof process !== "undefined" && process.env && process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

const cloudinaryApiKeyFromEnv =
  typeof process !== "undefined" && process.env && process.env.REACT_APP_CLOUDINARY_API_KEY;

export const config = {
  apiBaseUrl: apiBaseFromEnv || "http://localhost:8787",
  cloudinaryCloudName: cloudinaryCloudFromEnv || "dvqt2rsla",
  cloudinaryApiKey: cloudinaryApiKeyFromEnv || "541415784158454",
};

export default config;
